var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10991",
    "data-name": "Group 10991",
    transform: "translate(-123 -398)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_8656",
    "data-name": "Rectangle 8656",
    transform: "translate(123 398)",
    fill: "#fff",
    stroke: "rgba(112,112,112,0.25)",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 41,
    height: 41,
    rx: 4.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "qr-code",
    transform: "translate(136.001 411)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30776",
    "data-name": "Path 30776",
    d: "M1013.529,598.187a3.5,3.5,0,0,1-.507-.216,1.373,1.373,0,0,1-.678-1.159c-.012-1.042-.013-2.08,0-3.12a1.409,1.409,0,0,1,1.311-1.311q1.567-.022,3.135,0a1.419,1.419,0,0,1,1.329,1.135c.005.028-.007.065.031.08v3.374a1.378,1.378,0,0,1-1.218,1.218Z",
    transform: "translate(-1002.157 -582.19)",
    fill: "#292d32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30777",
    "data-name": "Path 30777",
    d: "M768.05,593.545a.76.76,0,0,0,.087-.242,1.413,1.413,0,0,1,1.288-.943q1.56-.017,3.119,0a1.409,1.409,0,0,1,1.312,1.311q.022,1.559,0,3.12a1.411,1.411,0,0,1-1.166,1.348c-.02,0-.042.005-.05.028h-3.4a1.416,1.416,0,0,1-1.187-1.187Z",
    transform: "translate(-768.049 -582.172)",
    fill: "#292d32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30778",
    "data-name": "Path 30778",
    d: "M772.651,348.05c.086.027.174.052.259.083a1.407,1.407,0,0,1,.958,1.308q.018,1.552,0,3.1a1.41,1.41,0,0,1-1.3,1.31q-1.551.026-3.1,0a1.419,1.419,0,0,1-1.371-1.106c-.008-.028,0-.064-.035-.08v-3.436a1.378,1.378,0,0,1,1.25-1.187Z",
    transform: "translate(-768.058 -348.048)",
    fill: "#292d32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30779",
    "data-name": "Path 30779",
    d: "M768.05,489.586a.914.914,0,0,1,.292-.431.84.84,0,0,1,.53-.143q2.093,0,4.186,0a.737.737,0,0,0,.794-.6c.02-.1,0-.2.03-.292a.732.732,0,0,1,1.444.132.718.718,0,0,0,.734.762.723.723,0,0,1,.717.794q0,2.116,0,4.232a.731.731,0,0,1-1.292.529.767.767,0,0,1-.167-.521v-1.281a.734.734,0,0,0-.782-.84.742.742,0,0,1-.674-.687.73.73,0,0,0-.82-.771c-1.369,0-2.738-.008-4.107,0a.815.815,0,0,1-.884-.578Z",
    transform: "translate(-768.049 -481.744)",
    fill: "#292d32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30780",
    "data-name": "Path 30780",
    d: "M984.68,439.643a.906.906,0,0,1-.292.431.766.766,0,0,1-.467.143h-4.294a.714.714,0,0,1-.763-.714.725.725,0,0,0-.761-.736.732.732,0,0,1,.014-1.464.729.729,0,0,0,.747-.767,2.568,2.568,0,0,1,.025-.559,1.094,1.094,0,0,1,2.162.239c.008.58.017,1.166,0,1.75a.752.752,0,0,0,.8.8c.65-.008,1.3.01,1.952-.006a.807.807,0,0,1,.884.577Z",
    transform: "translate(-968.683 -431.489)",
    fill: "#292d32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30781",
    "data-name": "Path 30781",
    d: "M943.2,348.05a1.079,1.079,0,0,1,.347.2.735.735,0,0,1,.225.545v.609a.742.742,0,0,0,.778.833.726.726,0,0,1,.054,1.442,2.506,2.506,0,0,0-.308.042.718.718,0,0,0-.523.726c-.006.25.005.5-.008.75a.708.708,0,0,1-.627.667.722.722,0,0,1-.8-.524,1.218,1.218,0,0,1-.027-.31c0-1.342.01-2.684-.008-4.026a.882.882,0,0,1,.549-.951Z",
    transform: "translate(-935.045 -348.048)",
    fill: "#292d32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30782",
    "data-name": "Path 30782",
    d: "M1101.726,436.583c-.049.042-.042.1-.059.155a1.094,1.094,0,0,1-2.126-.367,1.088,1.088,0,0,1,.9-1.072,1.073,1.073,0,0,1,1.255.845c0,.012.018.022.027.033Z",
    transform: "translate(-1085.729 -431.645)",
    fill: "#292d32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30783",
    "data-name": "Path 30783",
    d: "M1013.656,348.05a1.751,1.751,0,0,1,.458.215,1.094,1.094,0,0,1-.826,1.957,1.094,1.094,0,0,1-.058-2.148.242.242,0,0,0,.053-.025Z",
    transform: "translate(-1002.191 -348.048)",
    fill: "#292d32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30784",
    "data-name": "Path 30784",
    d: "M1101.732,349.362c-.052.026-.038.083-.052.123a1.094,1.094,0,0,1-2.133-.294,1.086,1.086,0,0,1,.869-1.116c.013,0,.023-.016.035-.025h.375a1,1,0,0,1,.906.906Z",
    transform: "translate(-1085.736 -348.048)",
    fill: "#292d32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30785",
    "data-name": "Path 30785",
    d: "M943.079,698.44a1.1,1.1,0,0,1-.347-.2.739.739,0,0,1-.15-.857.725.725,0,0,1,.761-.393.73.73,0,0,1,.175,1.393l-.125.055Z",
    transform: "translate(-935.237 -682.443)",
    fill: "#292d32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30786",
    "data-name": "Path 30786",
    d: "M769.259,348a1.606,1.606,0,0,0-.943.554,2.323,2.323,0,0,0-.307.633c0-.37,0-.739,0-1.109,0-.067.013-.081.08-.08C768.48,348,768.871,348,769.259,348Z",
    transform: "translate(-768.01 -348)",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30787",
    "data-name": "Path 30787",
    d: "M1122.71,703.978a1.9,1.9,0,0,0,.713-.347,1.7,1.7,0,0,0,.505-.871v1.14c0,.067-.013.081-.08.08C1123.472,703.974,1123.09,703.978,1122.71,703.978Z",
    transform: "translate(-1107.934 -687.981)",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30788",
    "data-name": "Path 30788",
    d: "M768,703.46a2.524,2.524,0,0,0,.268.58,1.486,1.486,0,0,0,.782.552c.045.013.106,0,.137.055-.37,0-.739,0-1.109,0-.067,0-.081-.013-.08-.08C768,704.2,768,703.83,768,703.46Z",
    transform: "translate(-768 -688.652)",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30789",
    "data-name": "Path 30789",
    d: "M1131.156,348.908a1.152,1.152,0,0,0-.594-.787c-.1-.049-.208-.08-.312-.119.276,0,.552,0,.828,0,.067,0,.083.013.08.08C1131.151,348.356,1131.156,348.632,1131.156,348.908Z",
    transform: "translate(-1115.16 -348)",
    fill: "#fdfdfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30790",
    "data-name": "Path 30790",
    d: "M1048.776,630.293c-.432,0-.863,0-1.295,0-.1,0-.142-.02-.142-.134q.008-1.311,0-2.621c0-.107.025-.141.137-.14q1.319.007,2.637,0c.093,0,.125.02.125.119q-.006,1.326,0,2.652c0,.113-.042.125-.136.123C1049.659,630.291,1049.218,630.293,1048.776,630.293Z",
    transform: "translate(-1035.703 -615.76)",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30791",
    "data-name": "Path 30791",
    d: "M804.509,630.3c-.426,0-.853,0-1.279,0-.107,0-.152-.014-.15-.14q.01-1.31,0-2.621c0-.113.035-.135.141-.135q1.311.006,2.621,0c.113,0,.136.036.135.141q-.006,1.311,0,2.621c0,.115-.038.135-.142.133C805.393,630.3,804.951,630.3,804.509,630.3Z",
    transform: "translate(-801.619 -615.77)",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30792",
    "data-name": "Path 30792",
    d: "M805.927,384.574c0,.437,0,.875,0,1.311,0,.1-.02.144-.135.143q-1.319-.007-2.638,0c-.093,0-.125-.02-.125-.12q.006-1.333,0-2.669c0-.094.034-.109.117-.109q1.327,0,2.653,0c.109,0,.125.038.125.134C805.925,383.7,805.927,384.136,805.927,384.574Z",
    transform: "translate(-801.571 -381.667)",
    fill: "#fefefe"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCode);
export default __webpack_public_path__ + "static/media/code.5b1699c492fc776cb72e8b75dbf67618.svg";
export { ForwardRef as ReactComponent };